import { render, staticRenderFns } from "./MKBTreeLevel.vue?vue&type=template&id=2e01adeb&scoped=true"
import script from "./MKBTreeLevel.vue?vue&type=script&lang=js"
export * from "./MKBTreeLevel.vue?vue&type=script&lang=js"
import style0 from "./MKBTreeLevel.vue?vue&type=style&index=0&id=2e01adeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e01adeb",
  null
  
)

export default component.exports